// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1872) return "static/chunks/1872-da00bf76271eeab3.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2831":"b5c69090","4228":"d88ffec7"}[chunkId] || chunkId) + "." + {"507":"d8add20751126dea","1652":"3d1bde8ee5f244dc","2831":"f70d68696f315ac2","2840":"e4f9219d3c28872a","4180":"5e28825f0db936ed","4228":"90a686452bfbfcca","4951":"f44f376238ed472e","5023":"3ff9c5bfa716c9ab","5136":"eafdc85812182611","9367":"78757646e5df0e94"}[chunkId] + ".js";
};